import { render, staticRenderFns } from "./NewEmployeeSalaryStatistics.vue?vue&type=template&id=abb7301a&scoped=true"
import script from "./NewEmployeeSalaryStatistics.vue?vue&type=script&lang=js"
export * from "./NewEmployeeSalaryStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb7301a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abb7301a')) {
      api.createRecord('abb7301a', component.options)
    } else {
      api.reload('abb7301a', component.options)
    }
    module.hot.accept("./NewEmployeeSalaryStatistics.vue?vue&type=template&id=abb7301a&scoped=true", function () {
      api.rerender('abb7301a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/employeeStatistics/NewEmployeeSalaryStatistics.vue"
export default component.exports